<template>
  <div>
    <app-header title="Screen Protector Types">
      <b-button v-router-link="{name:'screenprotectortype-editor',params:{id:'new'}}" variant="primary">
        <i class="fa fa-plus-circle" /> New Screen Protector Type
      </b-button>
    </app-header>
    <loading-spinner v-if="!screenprotectortypes" />
    <b-container v-else>
      <b-row>
        <b-col>
          <search-input v-model="query" />
        </b-col>
        <b-col class="text-right">
          {{ total }} Screen Protector Types
        </b-col>
      </b-row>
      <b-card-group columns>
        <b-card no-body
          v-for="screenprotectortype in displayScreenprotectortypes"
          :key="screenprotectortype.id"
          v-router-link="{name:'screenprotectortype-detail',params:screenprotectortype}"
          
        >
          <img :src="'https://cdn.gokaizen.com/' + screenprotectortype.src" alt="" style="max-width:100%;">
          <b-card-body>
            <h3>{{ screenprotectortype.name }}</h3>
            <p>Screen Protector Type</p>
          </b-card-body>
        </b-card>
      </b-card-group>
      <infinite-scrolling @infiniteHandler="infiniteHandler" />
    </b-container>
  </div>
</template>

<script>
import $api from '@/services/api';
import $search from '@/services/search';
import AppHeader from '@/components/AppHeader';
import SearchInput from '@/components/SearchInput';
import LoadingSpinner from '@/components/LoadingSpinner';
import InfiniteScrolling from '@/components/InfiniteScrolling';

export default {
  components: {
    AppHeader,
    SearchInput,
    LoadingSpinner,
    InfiniteScrolling,
  },

  data() {
    return {
      query: '',
      screenprotectortypes: null,
      page: 0,
      perPage: 7,
    };
  },

  computed: {
    displayScreenprotectortypes() {
      return $search(this.screenprotectortypes, this.query).slice(0, this.perPage * this.page);
    },

    total() {
      return (this.query) ? this.displayScreenprotectortypes.length : this.screenprotectortypes.length;
    },
  },

  created() {
    this.refreshData();
  },

  methods: {
    refreshData() {
      $api.get('/v1/internal/screenprotectortypes').then((screenprotectortypes) => {
        this.screenprotectortypes = screenprotectortypes;
      });
    },

    infiniteHandler($state) {
      if ((this.perPage * this.page) <= this.screenprotectortypes.length) {
        this.page += 1;
        $state.loaded();
      } else {
        $state.complete();
      }
    },
  },
};
</script>
